import {
  createSender, r, createRemover,
} from '@/resource/resource'

import {
  prefixAPI,
  API_BASE_URL,
} from '@/resource/api'

const AUTH_MODEL = 'auth'
const MODEL_FIREBASE = 'firebase/authentication'
const TWO_FACTOR = '2factor'
const PASSWORD_MODEL = 'auth/password'
const PHONE_MODEL = 'auth/phone'
// const AUTHENTICATE_LINK = prefixAPI('/login/', MODEL)

const TWO_FACTOR_CONFIRM = prefixAPI('/confirm/', TWO_FACTOR)
const TWO_FACTOR_REQUEST = prefixAPI('/request-confirmation/', TWO_FACTOR)

const LOGIN_LINK = prefixAPI('/login/', AUTH_MODEL)
const LOGOUT_LINK = prefixAPI('/logout/', AUTH_MODEL)
const REGISTRATION_LINK = prefixAPI('/registration/', AUTH_MODEL)
const REGISTRATION_CHECK_LINK = prefixAPI('/registration/check-login/', AUTH_MODEL)

const PASSWORD_RESET_REQUEST = prefixAPI('/reset/request/', PASSWORD_MODEL)
const PASSWORD_SET_NEW = prefixAPI('/reset/set-new/', PASSWORD_MODEL)
const PASSWORD_CHANGE = prefixAPI('/change/', PASSWORD_MODEL)

const PHONE_CHANGE = prefixAPI('/change/', PHONE_MODEL)
const PHONE_CHANGE_REQUEST = prefixAPI('/change/request/', PHONE_MODEL)

export const twoFactorConfirmResource = createSender(TWO_FACTOR_CONFIRM)
export const twoFactorRequestResource = createSender(TWO_FACTOR_REQUEST)

const FIREBASE_AUTH_LINK = '/auth/'
const FIREBASE_LIST_LINK = '/list/'
const FIREBASE_CREATE_CONNECT_LINK = '/create/'
const FIREBASE_DELETE_CONNECT_LINK = '/delete/{id}/'


export const loginResource = createSender(LOGIN_LINK)
export const logoutResource = createSender(LOGOUT_LINK)

export const registrationResource = createSender(REGISTRATION_LINK)
export const registrationCheckResource = createSender(REGISTRATION_CHECK_LINK)

export const passwordResetRequestResource = createSender(PASSWORD_RESET_REQUEST)
export const passwordSetNewResource = createSender(PASSWORD_SET_NEW)
export const passwordChangeResource = createSender(PASSWORD_CHANGE)

export const phoneChangeResource = createSender(PHONE_CHANGE)
export const phoneChangeRequestResource = createSender(PHONE_CHANGE_REQUEST)

export const firebaseAuthRequest = r(
  FIREBASE_AUTH_LINK, MODEL_FIREBASE, createSender
)
export const firebaseListRequest = r(
  FIREBASE_LIST_LINK, MODEL_FIREBASE
)
export const firebaseCreateConnectRequest = r(
  FIREBASE_CREATE_CONNECT_LINK, MODEL_FIREBASE, createSender
)
export const firebaseDeleteConnectRequest = r(
  FIREBASE_DELETE_CONNECT_LINK, MODEL_FIREBASE, createRemover
)

